import React, { useState } from "react";
import {
  Form,
  Input,
  DatePicker,
  Table,
  InputNumber,
  Select,
  Upload,
  Button,
  Row,
  Col,
  Card,
  message,
  notification,
  Typography,
  Checkbox,
} from "antd";
import {
  PlusOutlined,
  UploadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { useEffect } from "react";
import { set } from "lodash";
const { Option } = Select;
const { Title, Text } = Typography;

const CreatePurchaseRequest = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [materialsData, setMaterialsData] = useState({
    data: [],
    loading: false,
  });
  const [rows, setRows] = useState([]);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [materlalCategorySelect, setMaterialCategorySelect] = useState({
    data: [],
    loading: false,
  });
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const [tenantName, setTenantName] = useState("");

  const [firmTransactionProjectTypeList, setFirmTransactionProjectTypeList] =
    useState({
      data: [],
      loading: false,
    });

  const [firmSelected, setFirmSelected] = useState(false);

  useEffect(() => {
    RequestHandler.get(`/PurchaseRequest/GetEntityCode`).then((res) => {
      form.setFieldsValue({ name: res });
    });
    RequestHandler.get(`/MaterialCategory`).then((response) => {
      setMaterialCategorySelect({
        data: response?.value,
        loading: false,
      });
    });

    RequestHandler.get(
      `/Tenant/GetById/${localStorage.getItem("tenantId")}`
    ).then((res) => {
      setTenantName(res?.name);
    });
  }, []);

  const addRow = () => {
    setRows([
      ...rows,
      {
        key: Date.now(),
        quantity: null,
        unit: "",
        name: "",
        stockCode: "",
        stockId: null,
        materialCategoryId: null,
      },
    ]);
  };

  const updateRow = (key, field, value) => {
    setRows((prev) =>
      prev.map((row) => {
        if (row.key === key) {
          const updatedRow = { ...row, [field]: value };

          // Material seçildiğinde ad & kod doldur
          if (field === "stockId") {
            if (value) {
              const selected = materialsData.data.find((m) => m.id === value);
              if (selected) {
                updatedRow.name = selected.name;
                updatedRow.stockCode = selected.stockCode;
                updatedRow.unit = selected.unit || "";
                updatedRow.materialCategoryId =
                  selected.materialCategoryId || null;
              }
            } else {
              // Malzeme temizlenirse kategori de boşalsın
              updatedRow.materialCategoryId = null;
            }
          }

          return updatedRow;
        }
        return row;
      })
    );
  };

  const deleteRow = (key) => {
    setRows((prev) => prev.filter((row) => row.key !== key));
  };

  const columns = [
    {
      title: "Malzeme",
      dataIndex: "stockId",
      render: (value, record) => (
        <Select
          placeholder="(Opsiyonel). En az 2 harf giriniz.."
          value={value}
          allowClear
          showSearch
          onSearch={onMaterialSearch}
          onChange={(val) => updateRow(record.key, "stockId", val)}
          style={{ width: "100%" }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
        >
          {materialsData?.data?.map((m) => (
            <Option key={m.id} value={m.id}>
              {m.name}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true} // Malzeme seçiliyse readonly
        />
      ),
    },
    {
      title: "Kategori",
      dataIndex: "materialCategoryId",
      render: (value, record) => (
        <Form.Item style={{ marginBottom: 0 }}>
          <Select
            placeholder="Kategori"
            value={value}
            allowClear
            disabled={true} // Malzeme seçiliyse readonly
            showSearch
            onSearch={onMaterialCategorySearch}
            onChange={(val) => updateRow(record.key, "materialCategoryId", val)}
            style={{ width: "100%" }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {materlalCategorySelect?.data?.map((m) => (
              <Option key={m.id} value={m.id}>
                {m.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      ),
    },
    {
      title: "Miktar",
      dataIndex: "quantity",
      render: (value, record) => (
        <InputNumber
          min={0}
          value={value}
          onChange={(val) => updateRow(record.key, "quantity", val)}
        />
      ),
    },
    {
      title: "Birim",
      dataIndex: "unit",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true} // Malzeme seçiliyse readonly
          onChange={(e) => updateRow(record.key, "unit", e.target.value)}
        />
      ),
    },
    {
      title: "Sil",
      key: "action",
      render: (_, record) => (
        <Button
          danger
          type="link"
          icon={<DeleteOutlined />}
          onClick={() => deleteRow(record.key)}
        ></Button>
      ),
    },
  ];

  const onSuccess = () => {
    form.resetFields();
    setFiles([]);
    setTimeout(
      function () {
        history.push(`/purchase-request-list`);
      }.bind(this),
      2000
    );
  };

  const onFinish = (values) => {
    // Hatalı satırları tespit et
    const invalidRows = rows.filter((row) => {
      const hasMaterial = row.stockId || (row.name && row.name.trim() !== "");
      const validQuantity =
        typeof row.quantity === "number" && row.quantity > 0;
      const hasUnit = row.unit && row.unit.trim() !== "";

      return !hasMaterial || !validQuantity || !hasUnit;
    });

    if (invalidRows.length > 0) {
      invalidRows.forEach((row) => {
        setLoading(false);
        notification.error({
          message: "Hatalı Malzeme Satırı",
          description:
            row.name && row.name.trim() !== ""
              ? `${row.name} satırında eksik veya hatalı bilgi var.`
              : `Malzeme Adı belirtilmemiş satırda eksik veya hatalı bilgi var.`,
          placement: "topRight",
        });
      });
      return; // Hatalıysa devam etme
    }

    // Her şey uygunsa payload hazırla
    const payload = {
      ...values,
      desiredDeliveryDate: values.desiredDeliveryDate
        ? values.desiredDeliveryDate.format("YYYY-MM-DD")
        : null,
      purchaseRequestItemDtos: rows,
      //   files: files.map((f) => f.originFileObj),
    };

    const formData = new FormData();

    formData.append("jsonString", JSON.stringify(payload));
    // Files alanı: her dosyayı ayrı ayrı 'Files' olarak append et
    files.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    // API isteği (axios veya kendi RequestHandler’a göre)
    RequestHandler.post(
      `/PurchaseRequest`,
      formData,
      true,
      {},
      "multipart/form-data"
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onMaterialSearch = (value) => {
    if (value.length >= 2) {
      setMaterialsData({ data: [], loading: true });

      RequestHandler.get(
        `/PurchaseRequest/GetStockList?$select=id,name,stockCode,materialCategoryId,materialCategoryName,unit&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("stockCode", value)}`
      ).then((res) => {
        setMaterialsData({ data: res, loading: false });
      });
    } else {
      setMaterialsData({ data: [], loading: false });
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const onMaterialCategorySearch = (value) => {
    if (value.length >= 2) {
      setMaterialCategorySelect({ data: [], loading: true });

      RequestHandler.get(
        `/MaterialCategory?$select=id,name,code&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("code", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setMaterialCategorySelect({ data: res.value, loading: false });
      });
    } else {
      setMaterialCategorySelect({ data: [], loading: false });
    }
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/PurchaseRequest/GetFirmList?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onChangeFirm = (value) => {
    if (value) {
      // Firma seçilirse projeleri getir
      setFirmTransactionProjectTypeList({ data: [], loading: true });
      RequestHandler.get(
        `/FirmTransactionProjectType/GetListByFirmId/${value}`
      ).then((res) => {
        setFirmTransactionProjectTypeList({ data: res, loading: false });
      });
      setFirmSelected(true);
    } else {
      // Firma temizlenirse projeleri de temizle
      setFirmTransactionProjectTypeList({ data: [], loading: false, data: [] });
      setFirmSelected(false);
    }
  };

  return (
    <Form
      form={form}
      name="create-purchase-request"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row justify="center" style={{ padding: 20, paddingLeft: "20%" }}>
        <Col xs={24} md={20} lg={24}>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={[16, 16]}>
              {/* Sol taraf */}
              <Col xs={24} md={18}>
                <Card
                  title={
                    <span style={{ fontWeight: "bold", fontSize: 18 }}>
                      Talep Bilgileri
                    </span>
                  }
                  bordered={false}
                >
                  <Form.Item
                    label="Talep Kodu :"
                    name="name"
                    rules={[{ required: true, message: "Lütfen kod giriniz" }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Talep Başlığı :"
                    name="description"
                    // rules={[{ required: true, message: "Lütfen Açıklama giriniz" }]}
                  >
                    <Input.TextArea rows={3} />
                  </Form.Item>

                  <Form.Item
                    label="Proje Adı/Ünvanı :"
                    name="firmId"
                    rules={[
                      { required: true, message: "Lütfen proje seçiniz." },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onFirmSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmSelect.loading}
                      onChange={onChangeFirm}
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.firmBranchNumber}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Teslimat Deposu :"
                    name="transactionProjectTypeId"
                    rules={[
                      {
                        required: firmSelected,
                        message: "Lütfen teslimat deposu seçiniz.",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Teslimat Deposu"
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmTransactionProjectTypeList.loading}
                    >
                      {firmTransactionProjectTypeList.data.map((item) => (
                        <Select.Option
                          key={item.transactionProjectTypeId}
                          value={item.transactionProjectTypeId}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="İstenen Teslim Tarihi :"
                    name="desiredDeliveryDate"
                  >
                    <DatePicker
                      format="YYYY-MM-DD"
                      style={{ width: "30%" }}
                      disabledDate={(current) => {
                        // bugün dahil öncesini kapat
                        return current && current < moment().startOf("day");
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Malzeme Alım Amacı ve Kullanilacağı Yer :"
                    name="purposeOfPurchasing"
                  >
                    <Input.TextArea rows={3} />
                  </Form.Item>
                </Card>

                <Card
                  title={
                    <span style={{ fontWeight: "bold", fontSize: 18 }}>
                      Talep Malzemeleri
                    </span>
                  }
                  bordered={false}
                  style={{ marginTop: 16 }}
                >
                  <Button
                    type="dashed"
                    onClick={addRow}
                    icon={<PlusOutlined />}
                    style={{ marginBottom: 10 }}
                  >
                    Satır Ekle
                  </Button>
                  <Table
                    columns={columns}
                    dataSource={rows}
                    pagination={false}
                    rowKey="key"
                    scroll={{ x: "max-content" }}
                  />

                  <br></br>
                  <br></br>
                  <Form.Item
                    label={
                      <span style={{ fontWeight: "bold" }}>
                        Malzeme Hakkında Açıklama, Teknik Detaylar ve Varsa
                        Marka Bilgileri :
                      </span>
                    }
                    name="detailedDescription"
                  >
                    <Input.TextArea rows={6} />
                  </Form.Item>
                </Card>

                {/* //Onaylar */}


                <Card
                  title={
                    <span style={{ fontWeight: "bold", fontSize: 18 }}>
                      Dosyalar
                    </span>
                  }
                  bordered={false}
                  style={{ marginTop: 16 }}
                >
                  <Upload
                    multiple
                    beforeUpload={() => false}
                    onChange={({ fileList }) => setFiles(fileList)}
                    fileList={files}
                  >
                    <Button icon={<UploadOutlined />}>Dosya Yükle</Button>
                  </Upload>
                </Card>

                <Row justify="space-between">
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      htmlType="submit"
                      loading={loading}
                    >
                      Talep Ekle
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Form>
  );
};

export default CreatePurchaseRequest;
